import React, { useEffect } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import NavBar from "./NavBar";
import Button from "@mui/material/Button";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
    useOutletContext,
    useNavigate,
    useLocation,
    useLoaderData,
} from "react-router-dom";
import {
    getDeviceManufacturers,
    getDeviceModels,
    findDeviceModel,
} from "./lib/findDevice";

function searchModel({
    modelData,
    manufacturerValue,
    modelValue,
    setMatchedTv,
    navigate,
    pathname,
}) {
    const matchedModel = findDeviceModel(
        modelData,
        manufacturerValue,
        modelValue
    );

    if (matchedModel && (matchedModel.feature_ip || matchedModel.feature_sat)) {
        // Forward to success
        // The setMatchedTv passes the TV details up to the context of the App component
        // so that it can be used on the success page.
        setMatchedTv(matchedModel);
        navigate("/tv-match", { state: { previousPath: pathname } });
    } else if (!matchedModel) {
        // Forward to failure
        navigate("/no-match", {
            state: { previousPath: pathname },
        });
    }
}

function Input() {
    const modelData = useLoaderData();

    const {
        setMatchedTv,
        manufacturerValue,
        setManufacturerValue,
        modelValue,
        setModelValue,
    } = useOutletContext();
    const navigate = useNavigate();
    const { pathname, state } = useLocation();

    // Enable the search button?
    const bothSelected = modelValue;

    // On first page load should we clear the properties.
    useEffect(() => {
        // The search input values are passed back if the form input if the button is used.
        let previousPath;
        if (state) {
            ({ previousPath } = state);
        }

        // If the previous page was the success screen then don't prefil the values, only
        // to help correct a failed match.
        if (!previousPath || (previousPath && previousPath !== "/no-match")) {
            setManufacturerValue("");
            setModelValue("");
        }

        document.title = "HD+ Checker | Eingabe";
    }, [state, setManufacturerValue, setModelValue]);

    return (
        <div className="main-container">
            <Grid2 container style={{ width: "100%", zIndex: 0 }}>
                <NavBar />
                <Grid2 xs={12} style={{ marginTop: "6rem" }}>
                    <Grid2 xs={10} xsOffset={1}>
                        <Stack spacing={2}>
                            <Autocomplete
                                id="manufacturer"
                                freeSolo
                                options={getDeviceManufacturers(modelData)}
                                value={manufacturerValue}
                                renderInput={(params) => (
                                    <TextField {...params} label="Hersteller" />
                                )}
                                onChange={(event, newValue) => {
                                    setModelValue("");
                                    setManufacturerValue(newValue);
                                }}
                                onInputChange={(event, newValue) => {
                                    setManufacturerValue(newValue);
                                }}
                                clearIcon={<HighlightOffIcon />}
                            />
                            <Autocomplete
                                freeSolo
                                id="modelnumber"
                                options={getDeviceModels(
                                    modelData,
                                    manufacturerValue
                                )}
                                value={modelValue}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Modellnummer"
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    setModelValue(newValue);
                                }}
                                onInputChange={(event, newValue) => {
                                    setModelValue(newValue);
                                }}
                                clearIcon={<HighlightOffIcon />}
                            />
                            <Button
                                disabled={!bothSelected}
                                variant="contained"
                                style={{
                                    backgroundColor: "#202020",
                                    opacity: bothSelected ? 1 : 0.4,
                                    color: "white",
                                    marginTop: "3rem",
                                }}
                                onClick={() =>
                                    searchModel({
                                        modelData,
                                        manufacturerValue,
                                        modelValue,
                                        setMatchedTv,
                                        navigate,
                                        pathname,
                                    })
                                }
                            >
                                Check
                            </Button>
                        </Stack>
                    </Grid2>
                </Grid2>
            </Grid2>
        </div>
    );
}

export default Input;
